import { SurveyQuestion } from './types';

/**
 * Board Director Updated Role Survey — Todd Embley, April 2026
 * Context: OARA governance restructure — lighter board model, ED role created.
 * Goal: Give Todd a clear, low-friction path to stay on as Voting Director at Large.
 */
export const boardDirectorUpdatedRoleQuestions: SurveyQuestion[] = [

  // ── 1. Preferred path ────────────────────────────────────────────────────────
  {
    id: 'q1_preferred_path',
    type: 'radio',
    label: 'Given the updated, lighter board structure, what would you like to do?',
    required: true,
    options: [
      {
        value: 'stay_voting_director',
        label:
          'Stay on as a Voting Director at Large (Recommended) — Attend monthly meetings (virtual or in person) when time permits, weigh in on major decisions, and retain your vote. No secretary duties. No operational expectations. This is the path I am recommending because your perspective, network, and continuity matter to OARA.',
      },
      {
        value: 'step_back_advisory',
        label:
          'Step back to a Non-Voting Advisory role — If you still prefer not to hold a formal director position.',
      },
    ],
  },

  // ── Info: financial update ───────────────────────────────────────────────────
  {
    id: 'info_financial_update',
    type: 'info',
    label:
      'You flagged earlier that OARA needs a clearer financial foundation to sustain its activities. That concern has been heard and is being actively addressed. Our recent Canada Summer Jobs grant approval of approximately $11,500 is an early step toward building a sustainable funding base, and developing a broader revenue model is a core part of my mandate as volunteer ED.',
    required: false,
  },

  // ── 2. Open comments ────────────────────────────────────────────────────────
  {
    id: 'q2_comments',
    type: 'textarea',
    label: 'Any Other Comments? Is there anything else you want me to know before the meeting?',
    required: false,
    placeholder: 'Optional — feel free to share anything at all...',
  },

];
